<template>
    <v-container>
        <v-row v-if="!isResponseContact">
            <v-col cols="2">
                <v-btn @click="contactVSS()">Contact VSS</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="isResponseContact" pt-n5>
            <v-col>
                <v-textarea rows="1" label="Additional Response (Optional)" class="mx-2" v-model="mailItem.message" :disabled="sent || isLoading" @focus="contactVSS()"></v-textarea>
            </v-col>
        </v-row>
        <v-row v-if="contact && !isResponseContact">
            <v-col cols="12">
                For any questions or concerns use the box below to send VSS a message or call (307) 777-7591
            </v-col>
            <v-col cols="12" v-if="sent">
                Message Sent!
            </v-col>
            <v-col col="12" >
                <v-textarea autofocus auto-grow v-model="mailItem.message" :disabled="sent || isLoading" ></v-textarea>
            </v-col>
            <v-col col="2">
                <v-btn @click="sendMessage" :disabled="!ready || sent || isLoading || mailItem.message.length === 0">Send</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import verificationService from '@/services/verificationService'

export default {
    props: [ 'operationType', 'subOperationType', 'requestId', 'modType', 'numMatches' ],
    mounted () {
        this.setup()
    },
    data: function () {
        return {
            mailItem: {
                portalInboxMailId: 0,
                message: '',
                subMessage: '',
                toUsername: '',
                fromUsername: '',
                messageType: '',
                requestId: '',
                sentDate: '',
                modType: ''
            },
            sent: false,
            ready: false,
            isLoading: false,
            contact: false,
            isResponseContact: false
        }
    },
    methods: {
        setup () {
            this.isResponseContact = this.subOperationType === mailService.SubOperationEnum.ResponseContact
        },
        contactVSS () {
            this.contact = this.operationType !== null
            if (this.operationType === mailService.OperationEnum.Verification) {
                this.verificationContact()
            }
            if (this.operationType === mailService.OperationEnum.CertificateOrder) {
                this.certificateOrderContact()
            }
        },
        sendMessage () {
            if (this.mailItem.message) {
                this.isLoading = true
                //this.mailItem.sentDate = new Date() make sure to set this on the backend, UTC messes everything up
                mailService.sendMail(this.$http, this.mailItem).then(response => {
                    this.isLoading = false
                    this.sent = true
                })
            }
        },
        verificationContact () {
            if (this.numMatches == 0) {
                this.mailItem.messageType = 4
            } else if (this.numMatches == 1) {
                return // should probably not need to contact if is verified
            } else if (this.numMatches == 2) {
                this.mailItem.messageType = 3
            } else if (this.numMatches == null) {
                this.mailItem.messageType = 4
            } else {
                return // this shouldn't ever happen I don't think
            }
            this.mailItem.modType = this.modType
            if (this.requestId === 0) {
                verificationService.emptyVerification(this.$http, this.modType).then(response => {
                    this.requestId = response.data
                    this.mailItem.requestId = this.requestId
                    this.ready = true
                })
            } else {
                this.mailItem.requestId = this.requestId
                this.ready = true
            }
        },
        certificateOrderContact () {
            this.mailItem.messageType = 11
            this.mailItem.modType = this.modType
            if (this.requestId !== 0) {
                this.mailItem.requestId = this.requestId
            }
            this.ready = true
        }
    }
}
</script>
